<template>
  <div :class="$style.root">
    <div :class="$style.svg" :style="svgStyle" v-html="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/coin.svg')"></div>
    <div :class="coinClass" :style="coinStyle" ref="coin">{{ n }}</div>
  </div>
</template>

<script>
import { CountUp } from 'countup.js'

export default {
  props: {
    n: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 20,
    },
    appear: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: 0,
    },
    static: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      countUp: null,
      timeout: null,
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.timeout && clearTimeout(this.timeout)
  },
  computed: {
    svgStyle () {
      const size = this.size * 1.5
      return {
        'width': `${size}px`,
        'height': `${size}px`,
      }
    },
    coinStyle () {
      return {
        'font-size': `${this.size}px`,
      }
    },
    coinClass () {
      return [this.$style.coin]
    },
  },
  methods: {
    init () {
      const startVal = this.appear ? 0 : this.n
      this.countUp = new CountUp(this.$refs.coin, this.n, { startVal })
      this.timeout = setTimeout(() => {
        this.countUp.start()
      }, this.delay)
    },
  },
  watch: {
    'n' (newValue) {
      this.countUp.update(newValue)
    },
  },
}
</script>

<style lang="scss" module>
.root {
  @apply flex;
  color: #ff9200;
  @apply items-center;
}

.svg {
  @apply fill-current;
}

.coin {
  @apply leading-none;
}
</style>
